import { createSelector } from 'reselect'

import { selectAssortmentState } from './selectAssortmentState'

export const selectAssortmentGroupsData = createSelector([selectAssortmentState], (state) => {
  return state.groups.data
})
